import React, { useEffect, useState } from "react";
import IcEnvelope from "../../../svg/ic-envelope1.svg";
import PhoneIcon from "./assets/phone.svg";
import nookies from "nookies";
import Link from "next/link";
import { useRouter } from "next/router";

const HeaderTop = ({ data }) => {
  const { locale, push, pathname, asPath } = useRouter();

  const changeLanguage = (event, language) => {
    event.preventDefault();
    nookies.set(null, "locale", language, { path: "/" });
    push(pathname, asPath, { locale: language });
  };

  return (
    <div className="header-top" dir={locale === "ar" ? "rtl" : "ltr"}>
      <div className="container">
        <div className="content">
          <div className="info" dir={locale}>
            <Link href={`mailto:${data?.socials?.email}`} target="_blank">
              <a className={`envelope  `}>
                <IcEnvelope
                  className="image"
                  alt="email-image"
                  width={20}
                  height={20}
                />
                {data?.socials?.email}
              </a>
            </Link>

            <Link href={`tel:${data?.socials?.phone}`}>
              <a className={`phone`}>
                <PhoneIcon className="image" alt="phone-image" />
                <span dir="ltr">{data?.socials?.phone}</span>
              </a>
            </Link>
          </div>
          <div className="language">
            <button
              onClick={(e) => changeLanguage(e, locale === "ar" ? "en" : "ar")}
              href="/"
            >
              {locale === "ar" ? "en" : "العربية"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
